import React, { FC } from 'react';
import { Route, Routes } from 'react-router';
import { AuthTest } from './AuthTest';

interface Props {}

export const ClientAdminApp: FC<Props> = props => {
    return (
        <>
            <Routes>
                <Route path="auth-test" element={<AuthTest />} />
                <Route path="/" index={true} element={<AuthTest />} />
            </Routes>
        </>
    );
};
